import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { updateQualitativeProject } from "./qualSurveysActions";

export function useProjectUpdate(organizationID, projectID) {
    const queryClient = useQueryClient();
    const [isSaving, setIsSaving] = useState(false);
    const [saveError, setSaveError] = useState(null);
    const [saveSuccess, setSaveSuccess] = useState(false);

    const save = async (payload) => {
        if (!organizationID || !projectID) return { success: false, message: "Missing org or project ID" };

        setIsSaving(true);
        setSaveError(null);
        setSaveSuccess(false);

        const result = await updateQualitativeProject({ organizationID, projectID, payload });
        console.log("result=>", result);

        if (result.success) {
            await queryClient.invalidateQueries({ queryKey: ["projectDetails", organizationID, projectID] });
            setSaveSuccess(true);
            setTimeout(() => setSaveSuccess(false), 2500);
        } else {
            if (result?.errors?.length) {
                setSaveError(result.errors[0].message || "Save failed. Please try again.");
            } else {
                setSaveError(result.message || "Save failed. Please try again.");
            }
        }

        setIsSaving(false);
        return result;
    };

    const clearError = () => setSaveError(null);

    return { save, isSaving, saveError, saveSuccess, clearError };
}